import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { ConsumerAccountDetails } from './ConsumerAccountDetails';

export class ConsumerAccountDetailsResource extends FBaseService {
  public async getConsumerAccountDetails(fiId:string, customerKasasaKey:string) : Promise<ConsumerAccountDetails> {
    const response:AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/account-details/customer/${customerKasasaKey}`,

    );
    const results:ConsumerAccountDetails = response.data.data;
    return results;
  }
}

export default ConsumerAccountDetailsResource;
